import React from 'react';
import { Form } from 'antd';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import { connect } from 'dva';
import ABSSearch from '../../ABSSearch';
import commonUtils from '../../../utils/commonUtils';
import { searchType } from '../../ABSSearch/utils';
import './index.less';

interface IInputProps {
  form: any;
  label: string;
  required?: boolean;
  id: string;
  validator?: (rule: any, value: any, callback: (msg: string) => any) => any;
  labelWidth: number;
  labelClassName: string;
  placeholder?: string;
  style?: React.CSSProperties;
  initialValue?: string[];
  dispatch?: any;
  expertSearchList?: any[];
  expertSearchLoading?: boolean;
  multipleMaxNum?: number;
  // labelInValue?: boolean;
  isForm?: boolean;
}

interface IInputState {}

const mapStateToProps = ({ account, loading }) => {
  return {
    expertSearchList: account.expertSearchList,
    expertSearchLoading: loading.effects['account/getSearchUserList']
  };
};

@connect(mapStateToProps)
export default class SearchForm extends React.Component<
  IInputProps,
  IInputState
> {
  constructor(props: IInputProps) {
    super(props);
    this.onSearch = debounce(this.onSearch, 500);
  }

  onChange = (value: any) => {
    // console.log('value: ', value);
  };

  onSearch = value => {
    const { dispatch } = this.props;
    if (!value) {
      return;
    }
    dispatch({
      type: 'account/getSearchUserList',
      payload: { name: value }
    });
  };

  searchValidator = (rule: any, value: any, callback: any) => {
    const multipleMaxNum = commonUtils.getValue(this.props, 'multipleMaxNum', 1);
    if (Array.isArray(value)) {
      if (value.length > multipleMaxNum) {
        callback(`只能选择${multipleMaxNum}个收件人`);
      } else if (value.length === multipleMaxNum) {
        callback();
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  render() {
    const {
      form,
      label,
      required,
      id,
      labelWidth,
      style,
      labelClassName,
      initialValue,
      // expertSearchList,
      // expertSearchLoading,
      placeholder,
      multipleMaxNum,
      // labelInValue,
      isForm
    } = this.props;
    const { getFieldDecorator } = form;
    const errorMessage = `请输入${label}`;

    return (
      <Form.Item
        label={
          <span
            className={classNames(labelClassName)}
            style={{ width: labelWidth }}
          >
            {label}
          </span>
        }
        colon={false}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        className="search-item-form"
      >
        {getFieldDecorator(id, {
          initialValue,
          rules: [
            {
              required: required ? required : false,
              message: errorMessage
            },
            { validator: this.searchValidator }
          ]
        })(
          <ABSSearch
            mode="multiple"
            type={searchType.expert}
            style={style}
            multipleMaxNum={multipleMaxNum}
            removeMarginBottom={true}
            noRenderTitle={true}
            placeholder={placeholder}
            isForm={isForm}
          />
        )}
      </Form.Item>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSForm/Search/index.tsx